<template>
  <div
    class="home_swiper_wrapper_m animated"
    v-if="options.isAni"
    :class="{ fadeInUp: options.isAni }"
  >
    <div class="swiper_m">
      <swiper
        :options="swiperOption"
        class="mySwiper"
        style="position: absolute; top: 0; left: 0; bottom: 0; right: 0"
        v-if="swiperList.length"
      >
        <swiper-slide v-for="(item, index) in swiperList" :key="index">
          <a :href="item.jump_link" :target="(isAnchor(item.jump_link) ? '_self' : '_blank')" @click.prevent="onSlideClick(item, $event)">
            <img :src="item.img_url" width="100%" />
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSwiper",
  props: {
    swiperList: Array,
  },
  data() {
    return {
      options: {
        isAni: false,
      },
      swiperOption: {
        pagination: ".home_swiper_wrapper_m .swiper-pagination",
        paginationClickable: true,
        grabCursor: true,
        loop: true,
        initialSlide: 0,
        autoplay: 500000,
        autoplayDisableOnInteraction: false,
        coverflow: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true,
        },
        observeParents: true,
      },
    };
  },
  methods: {
    isAnchor(link) {
      if (!link) return false;
      try {
        return link.indexOf('#HomeLatestGame') !== -1 || /HomeLatestGame/.test(link);
      } catch (e) { return false; }
    },
    onSlideClick(item, e) {
      // if link targets the HomeLatestGame anchor, handle navigation within the SPA
      const href = item && item.jump_link ? item.jump_link : '';
      if (this.isAnchor(href)) {
        try { sessionStorage.setItem('navigateToHomeLatestGame', '1'); } catch (err) {}
        try { window.__mbFooterNavLock = true; } catch (err) {}
        // set vuex flag so footer/nav shows game-list highlight
        try { this.$store && this.$store.commit('setIsShowHomeLatestGame', true); } catch (err) {}

        // if already on home route, smooth scroll; otherwise route then scroll
        if (this.$route && (this.$route.path === '/' || this.$route.path === '/home')) {
          this.$nextTick(() => {
            setTimeout(() => {
              const el = document.getElementById('HomeLatestGame');
              if (el) {
                const headerEl = document.querySelector('.header_m') || document.querySelector('.header') || document.querySelector('header');
                const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : (1.16 * parseFloat(getComputedStyle(document.documentElement).fontSize));
                const rect = el.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const target = Math.round(scrollTop + (rect.top - headerHeight));
                window.scrollTo({ top: target, behavior: 'smooth' });
              }
            }, 80);
          });
        } else {
          // push to home then scroll after render
          this.$router.push('/').then(() => {
            this.$nextTick(() => {
              setTimeout(() => {
                const el = document.getElementById('HomeLatestGame');
                if (el) {
                  const headerEl = document.querySelector('.header_m') || document.querySelector('.header') || document.querySelector('header');
                  const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : (1.16 * parseFloat(getComputedStyle(document.documentElement).fontSize));
                  const rect = el.getBoundingClientRect();
                  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                  const target = Math.round(scrollTop + (rect.top - headerHeight));
                  window.scrollTo({ top: target, behavior: 'smooth' });
                }
              }, 300);
            });
          }).catch(() => {});
        }

        // release global lock after short timeout
        setTimeout(() => {
          try { sessionStorage.removeItem('navigateToHomeLatestGame'); } catch (err) {}
          try { window.__mbFooterNavLock = false; } catch (err) {}
        }, 1400);
      } else {
        // external link - follow normally
        if (href) {
          // allow default by opening new tab
          window.open(href, '_blank');
        }
      }
    }
  },
  mounted() {
    this.isLoading = false;
    this.options.isAni = true;
  },
};
</script>

<style lang="stylus" scoped>
.home_swiper_wrapper_m {
  width: 100%;
  margin-top: 1.16rem;

  .swiper_m >>> .swiper-container {
    z-index: 0 !important;
  }

  .swiper_m >>> .swiper-pagination-bullet-active {
    background: #fcc916 !important;
  }

  .swiper_m >>> .swiper-pagination-bullet {
    width: 0.325rem;
    height: 0.325rem;
    opacity: 1;
    margin-left: 10px !important;
    box-sizing: border-box;
    border-radius: 100%;
    border: 1px solid #fcc916;
    background: none;
    cursor: pointer;
  }

  .swiper_m >>> .swiper-pagination-bullets {
    width: 100%;
    bottom: 5px !important;
  }

  .swiper_m {
    position: relative;
    z-index: 0;
    width: 100%;
    height: 0;
    padding-bottom: 156.6666667%;
    background: #dcdcdc;

    .swiper-container {
      width: 100%;

      .swiper-slide {
        a {
          width: 100%;
          height: 100%;
          position: relative;
          overflow: hidden;

          img {
            display: block
          }
        }
      }
    }
  }
}
</style>
